import { createFileRoute } from "@tanstack/react-router";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { KnowledgeBaseLayout, KnowledgeBaseOverview } from "~/components/knowledge-base/knowledge-base-layout";

export const Route = createFileRoute("/_dashboard/$datasetSlug/docs/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { datasetSlug } = Route.useParams();

  useBreadCrumbs([{ title: "Knowledge Base", link: `/${datasetSlug}/docs` }]);

  return (
    <KnowledgeBaseLayout
      datasetSlug={datasetSlug}
      title="Knowledge Base"
      description="Internal Quake docs for ownership rules, workflow behavior, and product expectations."
    >
      <KnowledgeBaseOverview datasetSlug={datasetSlug} />
    </KnowledgeBaseLayout>
  );
}
